module.exports = __webpack_public_path__ + "static/img/brees-2011-top-image.52237c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2011-top-image.jpg
// module id = ixnT
// module chunks = 1